import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './pages/LandingPage';
import SsostaaiPage from './pages/SsostaaiPage';
import DetekcegptPage from './pages/DetekcegptPage';
import FindmefontPage from './pages/FindmefontPage';
import HeattrackPage from './pages/HeattrackPage';
import RoyalsfPage from './pages/RoyalsfPage';
import SsostasnackbarPage from './pages/SsostasnackbarPage';
import GraduationPage from './pages/GraduationPage';
import PawsiePage from './pages/PawsiePage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <HelmetProvider>
      <Analytics />
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ssostaai" element={<SsostaaiPage />} />
          <Route path="/detekcegpt" element={<DetekcegptPage />} />
          <Route path="/findmefont" element={<FindmefontPage />} />
          <Route path="/heattrack" element={<HeattrackPage />} />
          <Route path="/royalsf" element={<RoyalsfPage />} />
          <Route path="/ssostasnackbar" element={<SsostasnackbarPage />} />
          <Route path="/graduation" element={<GraduationPage />} />
          <Route path="/pawsie" element={<PawsiePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  )
}

export default App
